<template >
    <div class="restore__container">
        <img :src="images.logo" alt="Март" class="restore__logo">
        <h2 class="restore__title">Восстановление пароля</h2>
        <form method="post" class="restore__form">
            <input-component inputType="password" v-model:meaning="restorePassword.password" @input="errors.password = ''" inputName="newPassword" inputContent="********" inputLabel="Введите новый пароль" :inputError="errors.password"/>
            <input-component inputType="password" v-model:meaning="confirmedPassword" inputName="confirmedPassword" inputContent="********" inputLabel="Повторите новый пароль" :inputError="confirmed"/>
            <div class="restore__button-box">
                <button-component buttonText="Восстановить пароль" class="restore__button" :class="{ restore__button_disabled: disabled }" :disabled="disabled"  @click.prevent="resetPassword"/>
            </div>
        </form>
    </div>
</template>
<script setup lang="ts">
import logo from '../assets/img/svg/logo.svg'
import InputComponent from '../shared/Form/Input/InputComponent.vue'
import buttonComponent from '../shared/buttonComponent.vue'
import toast from '../app/lib/hooks/errorToast'
import axios from '../app/lib/api'
import { ref, watch } from 'vue'
import router from '../app/router/router'
import { useRoute } from 'vue-router'
import { resetPasswordShema } from '../app/lib/shemas/updateUserShema'

const route = useRoute()
const images = {
    logo: logo
}
const restorePassword = ref({
    resetToken: route.query.resetToken as string,
    password: ""
})
const errors = ref({
    password: ""
})
const confirmedPassword = ref("")
const confirmed = ref("")
const disabled = ref(true)

async function resetPassword() {
    try {
        await resetPasswordShema.validate(restorePassword.value, { abortEarly: false })
        errors.value = {
            password: ""
        }
        try {
            const res = await axios.auth.resetPassword(restorePassword.value)
            toast("success", res.data.message)
            router.push({name: 'login'})
        } catch (error: any) {
            toast("error", error.response.data.message)
            error.response.data.errors?.forEach((item: any) => toast("error", item.message))
        }
    } catch (error: any) {
        // @ts-ignore
        error.inner.forEach((error) => {
            // @ts-ignore
            errors.value[error.path] = error.message
            if (error.path.includes("resetToken")) {
                toast('error', "Ошибка доступа")
            }
        })
    }
}

watch(() => [confirmedPassword.value, restorePassword.value.password], () => {
    if(confirmedPassword.value === restorePassword.value.password) {
        confirmed.value = ""
        disabled.value = false
    } else {
        confirmed.value = "Пароли должны совпадать"
        disabled.value = true
    }
})
</script>